import { getPluginTypeButtonParams } from './getPluginTypeButtonParams.ts';
import { getPluginTypeOrderParams } from './getPluginTypeOrderParams.ts';
import { getPluginTypePluginParams } from './getPluginTypePluginParams.ts';
import type {
  PluginTypeButtonParams,
  PluginTypeOrderParams,
  PluginTypePluginParams,
} from './PluginTypeParams.ts';
import { PLUGIN_TYPE_ENUM } from '../../PluginType.ts';
import type { ScriptParams } from '../getScriptParams.tsx';

const pluginTypeToFunctionMap = {
  [PLUGIN_TYPE_ENUM.BUTTON]: getPluginTypeButtonParams,
  [PLUGIN_TYPE_ENUM.ORDER]: getPluginTypeOrderParams,
  [PLUGIN_TYPE_ENUM.PLUGIN]: getPluginTypePluginParams,
} as const;

type GetParamsByPluginTypeResult<T extends PLUGIN_TYPE_ENUM> =
  T extends PLUGIN_TYPE_ENUM.BUTTON
    ? PluginTypeButtonParams
    : T extends PLUGIN_TYPE_ENUM.ORDER
      ? PluginTypeOrderParams
      : T extends PLUGIN_TYPE_ENUM.PLUGIN
        ? PluginTypePluginParams
        : never;

type GetParamsByPluginTypeArgs<T extends PLUGIN_TYPE_ENUM> = {
  pluginType: T;
  node: Element;
  projectType: string;
  scriptParams?: Partial<ScriptParams>;
};

export const getParamsByPluginType = <T extends PLUGIN_TYPE_ENUM>({
  pluginType,
  projectType,
  node,
  scriptParams,
}: GetParamsByPluginTypeArgs<T>): GetParamsByPluginTypeResult<T> => {
  const handler = pluginTypeToFunctionMap[pluginType];

  return handler({
    node,
    projectType,
    scriptParams,
  }) as GetParamsByPluginTypeResult<T>;
};
